export default "__VITE_ASSET__BIpLSrP$__"